/**
 * Modules the root admin can switch off per account (root-admin → ספקים → the account's card):
 * 'whatsapp', 'invoicing', 'crews', 'ai'. The list arrives with appData (disabledFeatures) and
 * lives in the store; menus, header buttons and settings tabs ask here before showing a module.
 * (The menu / catalog / booking switches have gates of their own and don't come through here.)
 */
export function featureDisabled(store, key) {

    var list = store && store.state && store.state.disabledFeatures;

    return Array.isArray(list) && list.indexOf(key) > -1;

}

export default featureDisabled;
